import { AbilitySubject, every, not } from "@cdv/jazz-auth";
import { User } from "../../api";
import { isAppuser } from "../utils";

export default function defineCompanyAbility(can: AbilitySubject<User>): void {
  can("read", not(isAppuser));
  can(["update", "create"], not(isAppuser));
}
